/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ regio: NonNullable<unknown>, datums: NonNullable<unknown> }} Planning_Vakanties_AdviesInputs */

const nl_planning_vakanties_advies = /** @type {(inputs: Planning_Vakanties_AdviesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Advies van de Rijksoverheid voor regio ${i?.regio}: ${i?.datums}.`)
};

/**

* @param {Planning_Vakanties_AdviesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_advies = /** @type {((inputs: Planning_Vakanties_AdviesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_AdviesInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_advies(inputs)
});
export { planning_vakanties_advies as "planning.vakanties.advies" }